export const oidcActions = {
	SET_AUTHENTICATED: 'oidc/setAuthenticated',
	/** @param {boolean} payload */
	setAuthenticated: (payload) => ({
		type: oidcActions.SET_AUTHENTICATED,
		payload,
	}),
	SET_USER: 'oidc/setUser',
	/** @prop {*} payload */
	setUser: (payload) => ({
		type: oidcActions.SET_USER,
		payload,
	}),
	SET_LOADING: 'oidc/setLoading',
	/** @prop {boolean} payload */
	setLoading: (payload) => ({
		type: oidcActions.SET_LOADING,
		payload,
	}),
	USER_FOUND: 'oidc/userFound',
	USER_EXPIRED: 'oidc/userExpired',
};

export default oidcActions;
